import { useTranslation } from "react-i18next";
import ConfirmDialog from "../../../common/ConfirmDialog";

interface StopUsingDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirmPlacement: () => void;
}

const ParcelPlacementConfirmationDialog = (props: StopUsingDialogProps) => {
  const { t } = useTranslation();

  const onConfirmFinishSenderRetrieval = () => {
    props.onConfirmPlacement();
    props.onClose();
  };

  return (
    <ConfirmDialog
      open={props.open}
      title={t("book_location.parcel_placement.confirm_dialog.title")}
      content={t("book_location.parcel_placement.confirm_dialog.description")}
      cancelText={t("itemRetrieval.lockerOpen.dialog.cancel_button")}
      confirmText={t("itemRetrieval.lockerOpen.dialog.confirm_button")}
      onClose={props.onClose}
      onConfirm={onConfirmFinishSenderRetrieval}
    />
  );
};

export default ParcelPlacementConfirmationDialog;
